export const heroStats = [
  { id: "lib", value: "120,000+", label: "在线影片存量" },
  { id: "update", value: "300+", label: "每日更新条目" },
  { id: "speed", value: "0.8s", label: "平均起播耗时" },
  { id: "genre", value: "20+", label: "细分内容分类" },
];

export const featuredMovies = [
  {
    id: "m01",
    title: "星际回声",
    genre: "科幻",
    year: 2025,
    region: "中国大陆",
    duration: "2小时18分",
    rating: 9.1,
    quality: "4K HDR",
    tags: ["硬核科幻", "太空", "孤独叙事"],
    blurb:
      "一支深空探测小队在环状行星背面接收到一段循环信号，随着信号被逐层解码，队员发现那段回声来自多年之后的自己。影片用极简对白和大量环境音构建压迫感，把“回家”这个母题放进无垠宇宙里重新审视。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20lone%20astronaut%20silhouette%20standing%20before%20a%20colossal%20ringed%20planet%2C%20deep%20crimson%20nebula%20behind%2C%20warm%20amber%20rim%20light%2C%20painterly%20texture%2C%20subtle%20film%20grain%2C%20plain%20dark%20background%2C%20no%20text%2C%20premium%20dramatic%20composition&width=600&height=900&seq=shenma-poster-01&orientation=portrait",
    tone: "primary",
  },
  {
    id: "m02",
    title: "长夜将尽",
    genre: "悬疑",
    year: 2024,
    region: "中国大陆",
    duration: "1小时56分",
    rating: 8.7,
    quality: "蓝光 1080P",
    tags: ["犯罪悬疑", "雨夜", "反转"],
    blurb:
      "一名退休法医被一封匿名信拉回三十年前的旧案。整部影片几乎发生在同一场大夜里，雨水、路灯与证词构成三重线索，真相直到最后一刻才随天亮一起浮现。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20rain%20slicked%20empty%20city%20street%20at%20night%20with%20a%20single%20streetlamp%2C%20lone%20figure%20in%20a%20long%20coat%20walking%20away%2C%20wet%20asphalt%20reflections%2C%20warm%20amber%20and%20crimson%20tones%2C%20painterly%2C%20film%20grain%2C%20no%20text%2C%20premium%20key%20art&width=600&height=900&seq=shenma-poster-02&orientation=portrait",
    tone: "accent",
  },
  {
    id: "m03",
    title: "山河故人录",
    genre: "剧情",
    year: 2023,
    region: "中国大陆",
    duration: "2小时32分",
    rating: 8.9,
    quality: "4K 高清",
    tags: ["家庭", "年代", "群像"],
    blurb:
      "从一张泛黄的地契开始，三代人的迁徙被折叠进一座将要被水库淹没的山村。导演用缓慢的横移长镜头记录山水，也记录告别。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20layered%20misty%20mountain%20ridges%20at%20dawn%20with%20a%20tiny%20solitary%20figure%20on%20a%20winding%20ridge%20path%2C%20soft%20golden%20light%2C%20ink%20wash%20texture%2C%20muted%20amber%20and%20terracotta%20tones%2C%20no%20text%2C%20poetic%20premium%20composition&width=600&height=900&seq=shenma-poster-03&orientation=portrait",
    tone: "secondary",
  },
  {
    id: "m04",
    title: "铁血荣光",
    genre: "动作",
    year: 2025,
    region: "中国大陆",
    duration: "2小时06分",
    rating: 8.4,
    quality: "蓝光 1080P",
    tags: ["战争", "兄弟情", "硬核"],
    blurb:
      "一支被困在山口的工程兵连队，要在四十八小时内抢通唯一补给线。影片把爆破、机械与人性压力揉进同一场调度，动作场面几乎全部实拍完成。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20an%20armored%20soldier%20silhouette%20against%20a%20wall%20of%20fire%20and%20flying%20sparks%2C%20heavy%20smoke%2C%20warm%20orange%20and%20crimson%20palette%2C%20dramatic%20contrast%2C%20film%20grain%2C%20plain%20dark%20background%2C%20no%20text%2C%20premium%20action%20key%20art&width=600&height=900&seq=shenma-poster-04&orientation=portrait",
    tone: "primary",
  },
  {
    id: "m05",
    title: "深海之光",
    genre: "冒险",
    year: 2024,
    region: "中国大陆",
    duration: "1小时48分",
    rating: 8.6,
    quality: "4K HDR",
    tags: ["海洋", "探索", "视觉奇观"],
    blurb:
      "载人潜器在六千米海沟失去动力，唯一的希望是一只会发光的未知生物。影片用大量实景水下摄影与微距镜头，让黑暗本身成为最亮的主角。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20bioluminescent%20deep%20sea%20trench%20with%20a%20tiny%20submersible%20casting%20one%20beam%20of%20light%20into%20the%20dark%2C%20glowing%20blue%20green%20organisms%2C%20teal%20and%20amber%20accents%2C%20painterly%20texture%2C%20no%20text%2C%20premium%20mysterious%20composition&width=600&height=900&seq=shenma-poster-05&orientation=portrait",
    tone: "secondary",
  },
  {
    id: "m06",
    title: "雾都疑云",
    genre: "悬疑",
    year: 2023,
    region: "中国香港",
    duration: "2小时02分",
    rating: 8.2,
    quality: "蓝光 1080P",
    tags: ["年代推理", "旧港", "群像"],
    blurb:
      "上世纪的老码头接连出现失踪案，一名报社记者循着船运名单一路查去，牵出整座城市的旧账。雾气既是环境，也是叙事手法。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20foggy%20old%20harbor%20at%20night%20lit%20by%20gas%20lamps%2C%20blurred%20lonely%20figure%20on%20a%20wooden%20pier%2C%20dense%20mist%2C%20warm%20amber%20and%20muted%20crimson%20tones%2C%20painterly%20vintage%20texture%2C%20no%20text%2C%20premium%20mystery%20key%20art&width=600&height=900&seq=shenma-poster-06&orientation=portrait",
    tone: "accent",
  },
  {
    id: "m07",
    title: "春山如笑",
    genre: "爱情",
    year: 2024,
    region: "中国大陆",
    duration: "1小时52分",
    rating: 8.0,
    quality: "蓝光 1080P",
    tags: ["治愈", "田园", "初恋"],
    blurb:
      "两个在城市里失意的人在返乡的春天相遇，从一片无人打理的花谷开始重新学着生活。全片几乎没有冲突，靠四季流转和小事推动情绪。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20blossoming%20green%20valley%20under%20a%20golden%20sunset%20with%20two%20distant%20figures%20on%20a%20flower%20path%2C%20soft%20warm%20light%2C%20painterly%20texture%2C%20romantic%20and%20gentle%20mood%2C%20no%20text%2C%20premium%20key%20art&width=600&height=900&seq=shenma-poster-07&orientation=portrait",
    tone: "accent",
  },
  {
    id: "m08",
    title: "青空之上",
    genre: "动画",
    year: 2025,
    region: "中国大陆",
    duration: "1小时40分",
    rating: 8.8,
    quality: "4K HDR",
    tags: ["合家欢", "奇幻", "成长"],
    blurb:
      "少年误闯悬浮在云端的群岛，为了修好一台会唱歌的旧机器，踏上横跨天空的旅程。美术风格明亮通透，是全家人一起看的轻松选择。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20key%20art%20of%20stylized%20floating%20islands%20in%20a%20bright%20sky%20filled%20with%20soft%20clouds%2C%20a%20small%20airship%20between%20them%2C%20warm%20golden%20and%20teal%20palette%2C%20painterly%20whimsical%20style%2C%20no%20text%2C%20premium%20family%20key%20art&width=600&height=900&seq=shenma-poster-08&orientation=portrait",
    tone: "secondary",
  },
];

export const categoryMovies = [
  {
    id: "c01",
    title: "雾港来客",
    genre: "悬疑",
    year: 2025,
    region: "中国大陆",
    duration: "1小时58分",
    rating: 8.5,
    quality: "4K 高清",
    tags: ["港口", "失踪案"],
    blurb: "一艘无人的货船清晨漂进港口，船上只留下二十三本写满日期的航海日志。",
    tone: "accent",
  },
  {
    id: "c02",
    title: "引力之外",
    genre: "科幻",
    year: 2024,
    region: "中国大陆",
    duration: "2小时12分",
    rating: 8.3,
    quality: "4K HDR",
    tags: ["空间站", "失联"],
    blurb: "空间站突然偏离轨道，留守的两名工程师必须在氧气耗尽前找到真正的推力来源。",
    tone: "secondary",
  },
  {
    id: "c03",
    title: "烟火人家",
    genre: "剧情",
    year: 2023,
    region: "中国大陆",
    duration: "2小时04分",
    rating: 8.6,
    quality: "蓝光 1080P",
    tags: ["市井", "家庭"],
    blurb: "一间开了四十年的老面馆要拆了，老板娘决定在关门前把所有老客人都请回来吃一碗面。",
    tone: "primary",
  },
  {
    id: "c04",
    title: "午夜计程",
    genre: "都市",
    year: 2025,
    region: "中国香港",
    duration: "1小时46分",
    rating: 7.9,
    quality: "蓝光 1080P",
    tags: ["深夜", "陌生人"],
    blurb: "一位夜班司机的车厢里，先后坐上六个不愿说出目的地的乘客。",
    tone: "accent",
  },
  {
    id: "c05",
    title: "笑口常开",
    genre: "喜剧",
    year: 2024,
    region: "中国大陆",
    duration: "1小时42分",
    rating: 7.6,
    quality: "高清 720P",
    tags: ["轻喜剧", "小城"],
    blurb: "小镇上两家对门理发店为了抢客人各出奇招，最后把整条街都卷了进来。",
    tone: "accent",
  },
  {
    id: "c06",
    title: "剑影孤城",
    genre: "武侠",
    year: 2023,
    region: "中国大陆",
    duration: "2小时20分",
    rating: 8.1,
    quality: "4K 高清",
    tags: ["武侠", "复仇"],
    blurb: "孤城被围第七天，守城人只剩一把断剑和一段无人相信的旧盟约。",
    tone: "primary",
  },
  {
    id: "c07",
    title: "向海而生",
    genre: "剧情",
    year: 2025,
    region: "中国大陆",
    duration: "1小时54分",
    rating: 8.7,
    quality: "4K HDR",
    tags: ["海洋", "纪实风"],
    blurb: "一群年轻渔民决定用三年时间，把一片被过度捕捞的海湾重新养回来。",
    tone: "secondary",
  },
  {
    id: "c08",
    title: "纸上迷城",
    genre: "悬疑",
    year: 2024,
    region: "中国大陆",
    duration: "2小时08分",
    rating: 8.4,
    quality: "蓝光 1080P",
    tags: ["推理", "建筑"],
    blurb: "一座按图纸却从未建成的城市，出现在一名建筑师失踪案的现场照片里。",
    tone: "accent",
  },
  {
    id: "c09",
    title: "风起长街",
    genre: "动作",
    year: 2025,
    region: "中国大陆",
    duration: "1小时56分",
    rating: 7.8,
    quality: "4K HDR",
    tags: ["追捕", "都市动作"],
    blurb: "一场横跨整条长街的追捕，从清晨开始，到日落才真正分出胜负。",
    tone: "primary",
  },
  {
    id: "c10",
    title: "木与光",
    genre: "动画",
    year: 2024,
    region: "中国大陆",
    duration: "1小时36分",
    rating: 8.9,
    quality: "4K HDR",
    tags: ["定格动画", "手作"],
    blurb: "一个木头小人在旧工坊的灯影里醒来，为了找回自己的影子走过四季。",
    tone: "secondary",
  },
  {
    id: "c11",
    title: "夏至未晚",
    genre: "爱情",
    year: 2023,
    region: "中国大陆",
    duration: "1小时50分",
    rating: 7.7,
    quality: "高清 720P",
    tags: ["青春", "校园"],
    blurb: "高考结束的那个夏天，两个约定好去同一座城市的人，各自改了志愿。",
    tone: "accent",
  },
  {
    id: "c12",
    title: "城市切片",
    genre: "都市",
    year: 2025,
    region: "中国大陆",
    duration: "2小时整",
    rating: 8.2,
    quality: "4K 高清",
    tags: ["群像", "纪录式"],
    blurb: "一条地铁线，一个二十四小时，十二个在城市里擦肩而过的普通人。",
    tone: "primary",
  },
];

export const rankingMovies = [
  {
    id: "r01",
    title: "江湖夜雨",
    genre: "武侠",
    score: 9.3,
    heat: "本周 128.6 万次点开",
    note: "雨夜楼顶的一场对剑长镜头，被很多观众反复回看。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20lone%20swordsman%20standing%20on%20a%20rainy%20pagoda%20rooftop%20at%20night%2C%20falling%20rain%20and%20lantern%20glow%2C%20warm%20amber%20and%20crimson%20tones%2C%20painterly%20martial%20arts%20texture%2C%20film%20grain%2C%20no%20text%2C%20premium%20key%20art&width=600&height=900&seq=shenma-poster-09&orientation=portrait",
  },
  {
    id: "r02",
    title: "都市浮光",
    genre: "都市",
    score: 9.0,
    heat: "本周 96.2 万次点开",
    note: "配乐与航拍把城市夜景拍出了呼吸感。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20neon%20washed%20city%20skyline%20at%20dusk%20with%20a%20single%20lone%20taxi%20in%20the%20foreground%2C%20warm%20amber%20and%20crimson%20reflections%2C%20painterly%20texture%2C%20film%20grain%2C%20no%20text%2C%20premium%20urban%20key%20art&width=600&height=900&seq=shenma-poster-10&orientation=portrait",
  },
  {
    id: "r03",
    title: "时间旅人",
    genre: "科幻",
    score: 8.8,
    heat: "本周 84.5 万次点开",
    note: "关于循环与选择的设定，讨论度很高。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20glowing%20clockwork%20corridor%20with%20a%20walking%20figure%20seen%20from%20behind%2C%20golden%20gear%20light%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20painterly%20texture%2C%20film%20grain%2C%20no%20text%2C%20premium%20key%20art&width=600&height=900&seq=shenma-poster-11&orientation=portrait",
  },
  {
    id: "r04",
    title: "末日边境",
    genre: "动作",
    score: 8.5,
    heat: "本周 79.1 万次点开",
    note: "实景爆破与尘暴调度，视听冲击力足。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20ruined%20highway%20in%20a%20dust%20storm%20with%20a%20single%20lone%20car%20driving%20toward%20the%20viewer%2C%20warm%20orange%20haze%2C%20painterly%20texture%2C%20film%20grain%2C%20no%20text%2C%20premium%20action%20key%20art&width=600&height=900&seq=shenma-poster-12&orientation=portrait",
  },
  {
    id: "r05",
    title: "小镇奇谈",
    genre: "喜剧",
    score: 8.2,
    heat: "本周 71.4 万次点开",
    note: "一本正经讲荒诞事，笑点密集。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20key%20art%20of%20a%20quirky%20small%20town%20main%20street%20at%20golden%20hour%20with%20colorful%20old%20shopfronts%2C%20warm%20amber%20and%20terracotta%20palette%2C%20painterly%20playful%20texture%2C%20no%20text%2C%20premium%20key%20art&width=600&height=900&seq=shenma-poster-13&orientation=portrait",
  },
];

export const rankingTabs = [
  { id: "heat", label: "热度榜" },
  { id: "score", label: "口碑榜" },
  { id: "fresh", label: "新片榜" },
];

export const seriesItems = [
  {
    id: "s01",
    title: "长风渡月",
    kind: "古装剧",
    episodes: "共 42 集",
    status: "每周更新",
    summary:
      "以一条废弃古渡口为线索，讲述两个家族三代人的兴衰往来，服化道考究，适合喜欢慢热群像的观众连续追看。",
    tone: "primary",
  },
  {
    id: "s02",
    title: "都市夜归人",
    kind: "都市剧",
    episodes: "共 24 集",
    status: "已完结",
    summary:
      "每集聚焦一个夜班职业，从急诊护士到代驾司机，用单元形式拼出城市的另一面，单集节奏紧凑，通勤时看刚好。",
    tone: "secondary",
  },
  {
    id: "s03",
    title: "我们的乐队",
    kind: "音乐综艺",
    episodes: "共 12 期",
    status: "每周五更新",
    summary:
      "六支素人乐队在同一个排练厅里磨合，从翻唱到原创，节目保留了几乎所有排练与争执的现场素材。",
    tone: "accent",
  },
  {
    id: "s04",
    title: "味道中国",
    kind: "美食纪录",
    episodes: "共 8 集",
    status: "已完结",
    summary:
      "沿着三条河流的走向记录地方食材与家常做法，镜头克制，配乐安静，适合当作背景慢慢看完。",
    tone: "accent",
  },
  {
    id: "s05",
    title: "手艺人家",
    kind: "人文纪录",
    episodes: "共 10 集",
    status: "更新中",
    summary:
      "走访十位仍在坚持手工技艺的匠人，记录一件器物从原料到成型的完整过程，节奏舒缓。",
    tone: "secondary",
  },
  {
    id: "s06",
    title: "星光大道之夜",
    kind: "盛典晚会",
    episodes: "共 3 场",
    status: "已上线",
    summary:
      "年度盛典的三场完整回放，包含舞台、颁奖与后台花絮，适合一次性看个够。",
    tone: "primary",
  },
];